import { connect } from 'react-redux';
import {
  getUsers,
  getUserMessages,
  sendCustomMessage,
} from 'core/slices/users';
import { getMasivos } from 'core/slices/masivos';
import {
  users,
  userMessages,
  masivos,
  profile,
  sucursal_id,
  number_of_unread_messages,
} from 'core/selectors';
import Chat from '../../../components/chat/Chat';

export default connect(
  state => ({
    users: users(state),
    userMessages: userMessages(state),
    masivos: masivos(state),
    profile: profile(state),
    sucursal_id: sucursal_id(state),
    number_of_unread_messages: number_of_unread_messages(state),
  }),
  {
    getUsers,
    getUserMessages,
    sendCustomMessage,
    getMasivos,
  },
)(Chat);
